import logoAbrasel from "assets/imgs/abrasel-logo.svg";
import logoMarketUp from "assets/imgs/marketUp.svg";
import logoPl7 from "assets/imgs/pl7.png";
import logoTicket from "assets/imgs/ticket.png";

export const partners = [
  {
    slug: "abrasel",
    name: "Abrasel",
    logo: logoAbrasel,
  },
  {
    slug: "marketup",
    name: "MarketUp",
    logo: logoMarketUp,
  },
  {
    slug: "pl7",
    name: "PL7 Serviços Integrados",
    logo: logoPl7,
  },
  {
    slug: "ticket",
    name: "Ticket",
    logo: logoTicket,
  },
  // others
];

export const slugs = partners.map((partner) => partner.slug);

export const getPartner = (slug) => {
  return partners.find(
    (partner) =>
      String(partner.slug).toLowerCase() ===
      String(decodeURIComponent(slug)).toLowerCase()
  );
};
